import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { Router } from "@angular/router";
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { LoginService } from './login.service';
import { nodeTypes } from '../../../app/app-constant';
import { routes } from '../../../app/routes.constant';
import { TagsService } from '../../services/tags.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  userLoggedIn: boolean;
  showPassword: boolean = false;
  loginForm: FormGroup;
  passwordType: string = 'password';
  incorrectUserPas: boolean = false;
  cordaError: string = '';
  apiNotFound: boolean = false;

  constructor(private userService: UserService, private router: Router, private formBuilder: FormBuilder, private loginService: LoginService, 
    private tagsService: TagsService) {
    this.userLoggedIn = loginService.loggedIn == 'Y' ? true : false;
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ngOnInit() {
    //this.tagsService.view({});

    /* this.activatedRoute.queryParams.subscribe(params => {
      const userId = params['userId'];
      console.log(userId);
    }); */
  }

  updateErrors() {
    this.incorrectUserPas = false;
    this.cordaError = '';
    this.apiNotFound = false;
  }

  login(): void {
    this.updateErrors();
    this.loginService.login({'username': this.loginForm.value.username, 'password': this.loginForm.value.password})
      .subscribe( res => {        
        /* if(res.role == nodeTypes.ADMIN) {
          let landingRoute = this.loginService.getLandingRoute();
          this.router.navigate([landingRoute]);
        } else {
          this.getUserData();
        } */

        if(res.role == nodeTypes.ADMIN) {
          let landingRoute = this.loginService.getLandingRoute();
          this.router.navigate([landingRoute]);
        } else if(res.role == nodeTypes.CUSTOMER) {
          this.getUserData();
        } else {
          this.incorrectUserPas = true;
        }
      },
      error => {
        if(typeof(error) == 'string') {
          this.incorrectUserPas = true;
        } else {
          this.apiNotFound = true;
        }
      });

    /* this.tagsService.link({
      "event_action" : "Login button click",
      "event_content": "Login"
    }); */
  }

  getUserData(): void {
    this.loginService.getUserData()
      .subscribe( res => {
          let landingRoute = this.loginService.getLandingRoute();
          this.router.navigate([landingRoute]);
		    },
        error => {
          this.cordaError = error;
          //console.log(error);
        });
  }

}
